import React from 'react'
import { useTaxSystem } from '../../hooks/useTaxSystem'

interface Props {
  rate: number
}

export const TaxLabel: React.FC<Props> = ({ rate }) => {
  const taxSystem = useTaxSystem()
  const label = taxSystem.abbreviation || taxSystem.name

  return (
    <span>
      {label} ({rate}%)
    </span>
  )
}
